export type ResolvedImageBuild = {
  manifestFound: boolean;
  manifestPath?: string;
  repoAccessible: boolean;
  image_version: string;
  gcp_project_id: string;
  gcp_region: string;
  gcp_zone: string;
  disk_size: number;
};

export type ImageBuildSettings = {
  image_version: string;
  gcp_project_id: string;
  gcp_region: string;
  gcp_zone: string;
  disk_size: number;
};

export const DEFAULT_IMAGE_BUILD_SETTINGS: ImageBuildSettings = {
  image_version: 'v1.0.0',
  gcp_project_id: 'redislabs-sa-training-services',
  gcp_region: 'us-east1',
  gcp_zone: 'us-east1-b',
  disk_size: 100,
};
